export default __webpack_public_path__ + "static/media/0.1-title-in-the-sky.6997fa26.png";